module.exports = __webpack_public_path__ + "static/media/bg-header-popup-rule.8f1469ba.png";